<div class='terminal-action-dialog'>
  <nb-card class='dialog-content'>
    <nb-card-header class='dialog-title-header'>
      <div class='dialog-title-container'>
        <div class='dialog-title'>
          <span>{{ 'GRANT_PASSAGE.INTERCOM' | translate }} {{ terminal.name }}</span>
        </div>
        <div>
          <nb-icon
            (click)='dismiss()'
            class='close-icon'
            icon='close'
            nbPrefix
            pack='eva'
            status='control'
          ></nb-icon>
        </div>
      </div>
    </nb-card-header>
    <nb-card-body>
      <div class='dialog-body-container'>
        <div class='dialog-body-container__actions'>
          <div class='p-section'>
            <app-terminal-title [terminal]='terminal'></app-terminal-title>
            <button (click)="openTerminalAction('showTerminalEvents')" [class]="getCssClass('showTerminalEvents')"
                    class='first menu-button' fullWidth nbButton>{{ 'TERMINAL_ACTIONS.RECENT_ACTIVITY' | translate }}
              <nb-icon icon='arrow-ios-forward-outline'></nb-icon>
            </button>
            <button (click)="openTerminalAction('grantAnonymousPassage')" [class]="getCssClass('grantAnonymousPassage')"
                    class='menu-button'
                    fullWidth nbButton>{{ 'GRANT_PASSAGE.ANONYMOUS_PASSAGE' | translate }}
              <nb-icon icon='arrow-ios-forward-outline'></nb-icon>
            </button>
            <button (click)="openTerminalAction('grantControlledPassage')"
                    [class]="getCssClass('grantControlledPassage')"
                    [ngClass]="showContextualActions ? 'last' : ''" class='menu-button'
                    fullWidth
                    nbButton>{{ 'GRANT_PASSAGE.CONTROLLER_PASSAGE' | translate }}
              <nb-icon icon='arrow-ios-forward-outline'></nb-icon>
            </button>
            <button (click)="openTerminalAction('manageTerminalStatus')"
                    *ngIf='!showContextualActions' [class]="getCssClass('manageTerminalStatus')" class='last'
                    class='menu-button'
                    fullWidth
                    nbButton>{{ 'TERMINAL_ACTIONS.MANAGE_STATUS' | translate }}
              <nb-icon icon='arrow-ios-forward-outline'></nb-icon>
            </button>
            <!--            <button (click)="openTerminalAction('manageAccessMode')" nbButton fullWidth>Lus toegangsmodus instellen<nb-icon icon="arrow-ios-forward-outline"></nb-icon></button>-->
            <!--            <button (click)="openTerminalAction('search')" nbButton fullWidth>Kenteken of abonneenummer zoeken<nb-icon icon="arrow-ios-forward-outline"></nb-icon></button>-->
            <!--            <button (click)="openTerminalAction('showTerminalScreen')" nbButton fullWidth>Kassa scherm tonen<nb-icon icon="arrow-ios-forward-outline"></nb-icon></button>-->
            <!--            <button (click)="openTerminalAction('manageTerminalStatus')" nbButton fullWidth>Station status veranderen<nb-icon icon="arrow-ios-forward-outline"></nb-icon></button>-->
          </div>
          <div *ngIf='showContextualActions' class='contextual-actions-container'>
            <p>
              {{ 'ACTIONS.TITLE' | translate }}
            </p>
            <div *ngFor='let action of filteredActions'>
              <app-action
                (actionCompleted)='onActionCompleted($event)'
                (preventToggleClick)='onPreventToggleClick($event)'
                [action]='action'
                [disableToggleClick]='disableToggleClick'
                [terminal]='terminal'
              ></app-action>
            </div>
          </div>
        </div>
        <div class='dialog-body-container__info'>
          <!--          <ng-container *ngComponentOutlet="activeComponent; context: {test: 1}">-->
          <!--          </ng-container>-->
          <app-anonymous-passage (changeComponent)='onChangeComponent($event)'
                                 *ngIf="currentAction === 'grantAnonymousPassage'" [action]="{type: 28, name: 'test'}"
                                 [terminal]='terminal'></app-anonymous-passage>
          <app-controlled-passage (changeComponent)='onChangeComponent($event)'
                                  *ngIf="currentAction === 'grantControlledPassage'" [action]="{type: 29, name: 'test'}"
                                  [terminal]='terminal'></app-controlled-passage>
          <app-identification *ngIf="currentAction === 'search'" [action]="{type: 29, name: 'test'}"
                              [terminal]='terminal'></app-identification>
          <app-terminal-screen *ngIf="currentAction === 'showTerminalScreen'"
                               [terminal]='terminal'></app-terminal-screen>
          <app-access-mode *ngIf="currentAction === 'manageAccessMode'" [terminal]='terminal'></app-access-mode>
          <app-terminal-events *ngIf="currentAction === 'showTerminalEvents'"
                               [terminal]='terminal'></app-terminal-events>
          <app-terminal-status *ngIf="currentAction === 'manageTerminalStatus'"
                               [filteredActions]='filteredActions'
                               [terminal]='terminal'
                               class='contextual-actions-container'></app-terminal-status>
        </div>
      </div>
    </nb-card-body>
    <nb-card-footer></nb-card-footer>
  </nb-card>
</div>
